import { z } from 'zod'

export const WORK_TASK_TRACKER_ISSUE_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerIssueResponseSchema = z.unknown()
export type WorkTaskTrackerIssueResponse = z.infer<typeof workTaskTrackerIssueResponseSchema>
